module.exports = __webpack_public_path__ + "static/media/ETANG_EQ_EXTERIEUR_RED.d642860d.webp";